/**
 * Componente FilterBar
 * Barra de filtros usando Select do Ant Design
 */

import React from "react";
import { Select, Space, Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";

const FilterBar = ({ filters, onFilterChange, className, showLabel = true, isMobile = false }) => {
  // Garante que filters seja sempre um array
  const filtersArray = Array.isArray(filters) ? filters : [];

  const handleFilterChange = (filterId, value) => {
    onFilterChange?.(filterId, value);
  };

  const clearAllFilters = () => {
    filtersArray.forEach(filter => {
      onFilterChange?.(filter.id || filter.key, null);
    });
  };

  const hasActiveFilters = filtersArray.some(f => f.value !== null && f.value !== "");

  return (
    <Space
      wrap
      className={className}
      style={{
        width: "100%",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "stretch" : "center",
      }}
    >
      {showLabel && (
        <span style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          width: isMobile ? "100%" : "auto",
          marginBottom: isMobile ? "8px" : "0"
        }}>
          <FilterOutlined />
          <span>Filtros:</span>
        </span>
      )}

      <div style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: "8px",
        width: isMobile ? "100%" : "auto",
        flexWrap: "wrap"
      }}>
        {filtersArray.map(filter => {
          const filterId = filter.id || filter.key;
          if (filter.type === "select") {
            return (
              <Select
                key={filterId}
                placeholder={filter.label}
                value={filter.value || undefined}
                onChange={value => handleFilterChange(filterId, value)}
                allowClear
                style={{
                  width: isMobile ? "100%" : "auto",
                  minWidth: isMobile ? "100%" : "150px"
                }}
                options={filter.options?.map(opt => ({
                  label: opt.label,
                  value: opt.value,
                }))}
              />
            );
          }

          return null;
        })}

        {hasActiveFilters && (
          <Button
            type="text"
            onClick={clearAllFilters}
            style={{ alignSelf: isMobile ? "flex-start" : "center" }}
          >
            Limpar todos
          </Button>
        )}
      </div>
    </Space>
  );
};

export default FilterBar;
